import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { ICity } from 'src/app/interfaces/city';
import { IArea } from 'src/app/interfaces/area';
import { IHolding } from 'src/app/interfaces/holding';
import { IProvince } from 'src/app/interfaces/province';
import { IPhoneType } from 'src/app/interfaces/phoneType';
import { CityService } from 'src/app/services/http/business/city/city.service';
import { AreaService } from 'src/app/services/http/business/area/area.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { TranslateService } from '@ngstack/translate';
import { PhoneTypeService } from 'src/app/services/http/business/phoneType/phone-type.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect } from '@angular/material';
import { ICompany } from 'src/app/interfaces/company';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';
import { ProvinceService } from 'src/app/services/http/business/province/provinces.service';
import { IError } from 'src/app/interfaces/error.interface';


@Component({
  selector: 'app-subsidiary-company-entry',
  templateUrl: './subsidiary-company-entry.component.html',
  styleUrls: ['./subsidiary-company-entry.component.css']
})
export class SubsidiaryCompanyEntryComponent implements OnInit {
  queryParams:any;
  cityList: ICity;
  areaList: IArea;
  CompanyForm: FormGroup;
  holdingList: IHolding[];
  provinceList: IProvince;
  phoneTypeList: IPhoneType;
  errors = new Array();
  errObject: any;
  param: string[];
  errorList: IError[] = [];
  provinceId: any;
  constructor(
    private fb: FormBuilder,
    private cityService: CityService,
    private areaService: AreaService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private subsidiaryCompanyService: SubsidiaryCompanyService,
    private provinceService: ProvinceService,
    private phoneTypeService: PhoneTypeService,
    private dialogRef: MatDialogRef<SubsidiaryCompanyEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) {
 }

  ngOnInit() {
    this.init();
    this.formControl();
    if (this.data && this.data.ListPhone) {
      this.initFormArray(this.data.ListPhone);
    } else {
      this.newForm();
    }

  }


  formControl(){
    this.CompanyForm = this.fb.group({
      
    Id: [this.data && this.data["Id"] ? this.data["Id"] : 0],
      
      CustomerTitle: [
        this.data && this.data["CustomerTitle"] ? this.data["CustomerTitle"] : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50),
          Validators.minLength(3)
        ])
      ],

      ManagementName: [
        this.data && this.data["ManagementName"] ? this.data["ManagementName"] : null,
        Validators.compose([
          Validators.required,Validators.maxLength(50),Validators.minLength(3)
        ])
      ],

      NationalID: [
        this.data && this.data["NationalID"] ? this.data["NationalID"] : null,
        Validators.compose([
          Validators.maxLength(15),
          Validators.pattern("^[0-9]*$")
        ])
      ],

      EconomicCode: [
        this.data && this.data["EconomicCode"]
          ? this.data["EconomicCode"]
          : null,
        Validators.compose([
          Validators.maxLength(16),
          Validators.pattern("^[0-9]*$")
        ])
      ],

      RegistrationID: [
        this.data && this.data["RegistrationID"]
          ? this.data["RegistrationID"]
          : null,
        Validators.compose([Validators.maxLength(15),Validators.pattern("^[0-9]*$")])
      ],

      ProvinceId: [
        this.data && this.data["ProvinceId"]
          ? this.data["ProvinceId"].toString()
          : null
      ],

      AddressDto: this.fb.group({
        CityId: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["CityId"]
            ? this.data["AddressDto"]["CityId"].toString()
            : null,
          Validators.compose([Validators.required])
        ],

        AreaId: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["AreaId"]
            ? this.data["AddressDto"]["AreaId"].toString()
            : null
        ],
        ProvinceId: [
          this.data && this.data["ProvinceId"]
            ? this.data["ProvinceId"].toString()
            : null
        ],

        Address: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["Address"]
            ? this.data["AddressDto"]["Address"]
            : null,
          Validators.compose([Validators.required, Validators.maxLength(250)])
        ],

        Longitude: [null],

        Latitude: [null],

        PostalCode: [
          this.data &&
            this.data["AddressDto"] &&
            this.data["AddressDto"]["PostalCode"]
            ? this.data["AddressDto"]["PostalCode"]
            : null,
          Validators.compose([Validators.pattern("^[0-9]{10}?$")])
        ]
      }),
      ListPhone: this.fb.array([])
    });
    // if (this.data && this.data.ListPhone) {
    //   this.initFormArray(this.data.ListPhone);
    // } else {
    //   this.newForm();
    // }
  }
  
  init() {
    this.loadProvience();
    this.loadPhoneType();
    if (this.data && this.data["ProvinceId"]) {
          this.provinceId=this.data["ProvinceId"]
      this.cityService.GetList(this.data["ProvinceId"]).subscribe(r => {
        this.cityList = r;

        if (this.data && this.data["CityId"]) {
          this.areaService.list(this.data["CityId"]).subscribe(e => {
            this.areaList = e;
          });
        }
      });
    }
  }

  newForm() {
   
    const creds = this.CompanyForm.controls.ListPhone as FormArray;
    creds.push(
      this.fb.group({
        GuidId: new FormControl(""),
        PhoneNumber: new FormControl(
          null,
          Validators.compose([
            Validators.maxLength(11),
          ])
        ),
        PhoneType: new FormControl(null, Validators.required)
      })
    );
  }

  initFormArray(adresse) {

    if (adresse) {
      const formArray = this.CompanyForm.get("ListPhone") as FormArray;
      adresse.map(item => {
        formArray.push(this.editForm(item));
      });
      this.CompanyForm.setControl("ListPhone", formArray);
    }
  }
  
  editForm(list): FormGroup {
   
    let formGroup: FormGroup = new FormGroup({
      GuidId: new FormControl(list["GuidId"] ? list["GuidId"] : null),
      PhoneNumber: new FormControl(
        list["PhoneNumber"] ? list["PhoneNumber"] : null,
        Validators.maxLength(11)
      ),
      PhoneType: new FormControl(
        list["PhoneType"] ? list["PhoneType"].toString() : null,
        Validators.required
      )
    });
    return formGroup;
  }
  
  loadProvience() {
    this.provinceService.GetList().subscribe(
      res => {
        this.provinceList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  loadCity(element: MatSelect) {
    this.cityService.GetList(element.value).subscribe(
      res => {
        this.cityList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  loadArea(element: MatSelect) {
    this.areaService.list(element.value).subscribe(
      res => {
        this.areaList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPhoneType() {
    this.phoneTypeService.list().subscribe(
      res => {
        this.phoneTypeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  addPhone(): void {
    (<FormArray>this.CompanyForm.get("ListPhone")).push(
      new FormGroup({
        GuidId: new FormControl(""),
        PhoneNumber: new FormControl(
          null,
          Validators.compose([Validators.required, Validators.maxLength(11)])
        ),
        PhoneType: new FormControl(null)
      })
    );
  }
  removePhone(index: number) {
    if (index > 0)
      (<FormArray>this.CompanyForm.get("ListPhone")).removeAt(index);
  }

  submit(form: ICompany) {
   
    this.errors = new Array();
    if (this.data && this.data.Id) {
      this.subsidiaryCompanyService.customerEdit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    } else {
      this.subsidiaryCompanyService.addCustomer(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
